import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_7gb3t4sxaw: FaireBrandEntity = {
  token: "b_7gb3t4sxaw",
  type: "brand",
  name: "Life-Flo",
  avatarUrl:
    "https://cdn.faire.com/fastly/1616e429e6c6b4d636565200719c712b337f35fc45125e02b87f4270ce501973.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/71916a0041732dc3bba22f14b076ad1f9962ab55672f410e3ddea354249cc120.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/1616e429e6c6b4d636565200719c712b337f35fc45125e02b87f4270ce501973.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/71916a0041732dc3bba22f14b076ad1f9962ab55672f410e3ddea354249cc120.jpeg",
  location: "Salt Lake City, CA, USA",
  minimumOrderDollars: 139,
  rating: 5,
  reviewCount: 2,
  isInsider: true,
  description:
    "Life-flo. For body, mind & balance.\nFor over 25 years we have been committed to educating women about the biology behind hormone health and a body’s changes, while developing supplements to bring absolute balance to her life. We understand that change looks and feels different for everyone, which is why we’ve created a line of clean, high-quality products for every moment of a woman's changing life. We help you not just face the day, but do it head-on. The quality we stand for.\nLife-flo products are led by women, backed by science, developed using the latest research and cutting-edge technology. Manufactured in our own state-of-the-art facility, each item is packaged with consciousness to ensure the materials inside remain protected on their journey from us to you.",
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:51:59.775Z",
    importedBy: "entity-db-cli",
  },
};
